export type VideoStatus = 'new' | 'processing' | 'error' | 'done';

export type ResponseOfferVideo = {
	id: number;
	playlist: string;
	status: VideoStatus;
	video_name: string;
};

export type OfferVideo = {
	id: number;
	playlist: string;
	status: VideoStatus;
	videoName: string;
};

export function normalizeOfferVideo(video: ResponseOfferVideo): OfferVideo {
	return {
		id: video.id,
		playlist: video.playlist,
		status: video.status,
		videoName: video.video_name,
	};
}

export function isVideoFileType(src: string): boolean {
	return src.includes('video');
}
